import React, { useEffect, useState } from "react";
import TextField from "../../../Components/UI/Inputs/TextField.js";
import DropDown from "../../../Components/UI/Inputs/DropDown.js";
import Button from "../../../Components/UI/Buttons/Button";
import DateTime from "../../../Components/UI/Inputs/DateTime.js";
import useApi from "../../../Hooks/useApi";
import showToast from "../../../Helpers/toast";
import { useNavigate } from "react-router-dom";
import MultiLocationSelector from "../../../Components/UI/Inputs/LocationSelector/LocationSelectorContainer.js";
import { handleApiError } from "../../../Helpers/ErrorHandler";
import Common from "../../../Components/Layouts/Common.js";

const CreateSurvey = () => {
  const { request } = useApi();
  const [locations, setLocations] = useState([]);
  const [questionnaireList, setQuestionnaireList] = useState(null);
  const [allLocation, setAllLocation] = useState([]);
  const [projectList, setProjectList] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    startDate: "",
    endDate: "",
    questionnaireId: "",
    locations: [],
    projectId: "",
  });

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      ...formData,
      questionnaireId: formData.questionnaireId,
      projectId: formData.projectId,
      locations: locations?.map((location) => location?.id),
    };

    if (!data.questionnaireId) {
      showToast({ type: "error", message: "Questionnaire not slected" });
      return;
    }
    if (!data.projectId) {
      showToast({ type: "error", message: "Survey Project not specified." });
      return;
    }

    if (!(data.locations.length > 0)) {
      showToast({ type: "error", message: "Select at least one location." });
      return;
    }

    try {
      const response = await request(
        "POST",
        "/v1/survey",
        {
          data,
        },
        "survey_service"
      );

      showToast({ message: response.message });
      setFormData({
        name: "",
        startDate: "",
        endDate: "",
        questionnaireId: "",
        locations: null,
        projectId: "",
      });

      setTimeout(() => {
        navigate("/manage-survey");
      }, 1500);
    } catch (error) {
      // showToast({ type: "error", message: error?.response?.data?.message || "Error Happened" })
      handleApiError(error);
    }
  };

  const isEndDateValid = () => {
    if (!formData.startDate || !formData.endDate) return true;
    return new Date(formData.endDate) >= new Date(formData.startDate);
  };

  const fetchQuestionnaireList = async () => {
    try {
      const response = await request(
        "GET",
        "/v1/survey/questionnaires/list?status=COMPLETED",
        {},
        "survey_service"
      );

      if (response.content && response.content.length > 0) {
        setQuestionnaireList(
          response.content.map((questionnaireItem) => ({
            name: questionnaireItem.name,
            value: questionnaireItem.id,
          }))
        );
      }
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };
  const fetchSurveyProjectList = async () => {
    const response = await request(
      "GET",
      "/v1/survey/projects/list",
      {},
      "survey_service"
    );
    if (response.content) {
      if (response.content?.length > 0) {
        setProjectList(
          response.content.map((item) => ({
            value: item.id,
            name: item.projectName,
          }))
        );
      }
    }
  };
  const fetchLocations = async () => {
    try {
      const response = await request(
        "GET",
        "/v1/survey/locations",
        {},
        "survey_service"
      );
      if (response?.length > 0) {
        setAllLocation(response);
      }
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchLocations();
    fetchQuestionnaireList();
    fetchSurveyProjectList();
  }, []);

  return (
    <div className=" bg-white relative h-full">
      <Common headline={"Create New Survey"}>
        <form onSubmit={handleSubmit} className="text-start space-y-4 px-2 h-full">
          <TextField
            placeholder="Enter Survey Title"
            name="name"
            label={"Survey Title"}
            value={formData.name}
            onValueChange={handleInputChange}
            required
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-center ">
            <DropDown
              name="questionnaireId"
              value={formData.questionnaireId}
              label="Select Questionnaire"
              onValueChange={(value) =>
                handleInputChange("questionnaireId", value)
              }
              placeholder={"Select Questionnaire"}
              options={questionnaireList || []}
            />
            <DropDown
              name="projectId"
              value={formData.projectId}
              label="Select Survey Project"
              onValueChange={(value) => handleInputChange("projectId", value)}
              placeholder={"Select Project"}
              options={projectList || []}
            />

            <div className="col-span-full">
              <MultiLocationSelector
                locationList={allLocation}
                locations={locations}
                setLocations={setLocations}
              />
            </div>

            <DateTime
              label={"Start Date"}
              type="date"
              placeholder="Start Date"
              name="startDate"
              value={formData.startDate}
              onValueChange={handleInputChange}
              required
            />

            <DateTime
              label={"End Date"}
              type="date"
              minDate={formData.startDate}
              placeholder="End Date"
              name="endDate"
              value={formData.endDate}
              onValueChange={handleInputChange}
              required
              min={formData.startDate}
            />
          </div>

          {!isEndDateValid() && (
            <p className="text-red-500 text-sm">
              End date cannot be before start date.
            </p>
          )}

          {/* <Button
            type="btn-blue-full"
            label="Submit"
            backgroundColor="#2F4B7C"
            textColor="white"
            style={{
              height: "40px",
              width: "100%",
            }}
            disabled={!isEndDateValid()}
          /> */}


     <div className="flex justify-center ">
           <Button
            type="full"
            label="Submit"
          
            style={{
        
              width: "200px",
            }}
            disabled={!isEndDateValid()}
          />
   </div>
        </form>
      </Common>
    </div>
  );
};

export default CreateSurvey;
